import { AccessToken, AuthSession } from '../../../../types';
import { authenticatedSession } from './authenticatedSession';
import { awaitingTwoFactorSession } from './awaitingTwoFactorSession';
import { unauthenticatedSession } from './unauthenticatedSession';

/**
 * Applies a refreshed first-factor token/expiry to an existing session while
 * preserving its status and its second-factor token: a refresh over an
 * 'authenticated' session stays authenticated (carrying the 2FA token across),
 * over an 'awaiting-two-factor' session stays awaiting. Refreshing a
 * logged-out session is a no-op (stays unauthenticated).
 */
export const refreshedSession = (
  previous: AuthSession,
  jwt: AccessToken,
  expiresAt: string,
): AuthSession => {
  if (previous.status === 'authenticated') {
    return authenticatedSession(jwt, expiresAt, previous.twoFactorToken ?? '');
  }

  if (previous.status === 'awaiting-two-factor') {
    return awaitingTwoFactorSession(jwt, expiresAt);
  }

  return unauthenticatedSession();
};
